export const TEXTURE_SIZE = 1024;
export const FRAME_INSET_RATIO = 0.05;
export const ROUNDED_RADIUS_RATIO = 0.05;

export function computeTextureSize({ dimAspect }) {
  if (dimAspect >= 1) {
    return { width: TEXTURE_SIZE, height: Math.round(TEXTURE_SIZE / dimAspect) };
  }
  return { width: Math.round(TEXTURE_SIZE * dimAspect), height: TEXTURE_SIZE };
}

export function computePhotoRect({ canvasWidth, canvasHeight, whiteFrame }) {
  if (!whiteFrame) {
    return { x: 0, y: 0, w: canvasWidth, h: canvasHeight };
  }
  const inset = Math.min(canvasWidth, canvasHeight) * FRAME_INSET_RATIO;
  return {
    x: inset,
    y: inset,
    w: canvasWidth - 2 * inset,
    h: canvasHeight - 2 * inset
  };
}

export function computeCoverSourceRect({ imageWidth, imageHeight, destWidth, destHeight }) {
  const imgAspect = imageWidth / imageHeight;
  const dstAspect = destWidth / destHeight;
  if (imgAspect > dstAspect) {
    // image wider than dest — crop horizontal sides
    const sw = imageHeight * dstAspect;
    return {
      sx: (imageWidth - sw) / 2,
      sy: 0,
      sw,
      sh: imageHeight
    };
  }
  // image taller than dest — crop top/bottom
  const sh = imageWidth / dstAspect;
  return {
    sx: 0,
    sy: (imageHeight - sh) / 2,
    sw: imageWidth,
    sh
  };
}

export function computeContainDestRect({
  imageWidth,
  imageHeight,
  destX,
  destY,
  destWidth,
  destHeight
}) {
  const imgAspect = imageWidth / imageHeight;
  const dstAspect = destWidth / destHeight;
  if (imgAspect > dstAspect) {
    const dh = destWidth / imgAspect;
    return {
      dx: destX,
      dy: destY + (destHeight - dh) / 2,
      dw: destWidth,
      dh
    };
  }
  const dw = destHeight * imgAspect;
  return {
    dx: destX + (destWidth - dw) / 2,
    dy: destY,
    dw,
    dh: destHeight
  };
}
